module.exports = __webpack_public_path__ + "static/img/logo.d01e4671.png";